import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_COMPANY_TYPE_DEF,
  ADD_COMPANY_TYPE_DEF,
  UPDATE_COMPANY_TYPE_DEF,
  DELETE_COMPANY_TYPE_DEF,
} from "./actionTypes"

import {

  getCompanyTypeDefSuccess,
  addCompanyTypeDefSuccess,
  updateCompanyTypeDefSuccess,
  deleteCompanyTypeDefSuccess,
  companyTypeDefApiError
  
} from "./actions"

import {
getCompanyTypeDef,
addCompanyTypeDef,
updateCompanyTypeDef,
deleteCompanyTypeDef,

} from "../../helpers/backend_helper/backend_helper" 

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetCompanyTypeDef() {
  try {
    const response = yield call(getCompanyTypeDef)
    yield put(getCompanyTypeDefSuccess(response))
  } catch (error) {
    yield put(companyTypeDefApiError(error))
  }
}

function* onAddCompanyTypeDef({ payload: record }) {
  try {
    const response = yield call(addCompanyTypeDef, record)
    yield put(addCompanyTypeDefSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(companyTypeDefApiError(error))
  }
}

function* onUpdateCompanyTypeDef({ payload: record }) {
  try {
    const response = yield call(updateCompanyTypeDef, record)
    yield put(updateCompanyTypeDefSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(companyTypeDefApiError(error))
  }
}

function* onDeleteCompanyTypeDef({ payload: guid }) {
  try {
    const response = yield call(deleteCompanyTypeDef, guid)
    yield put(deleteCompanyTypeDefSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(companyTypeDefApiError(error))
  }
}

function* companyTypeDefSaga() {

    yield takeEvery(GET_COMPANY_TYPE_DEF,onGetCompanyTypeDef)
    yield takeEvery(ADD_COMPANY_TYPE_DEF,onAddCompanyTypeDef)
    yield takeEvery(UPDATE_COMPANY_TYPE_DEF,onUpdateCompanyTypeDef)
    yield takeEvery(DELETE_COMPANY_TYPE_DEF,onDeleteCompanyTypeDef)
}

export default companyTypeDefSaga